export const COUPON_FEE_CATEGORY = 'discount';
export const COUPON_FEE_SUBCATEGORY_PREFIX = 'coupon';
export const COUPON_CODE = 'coupon_code';
